import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IconFormat, Record } from 'src/app/models/record';
import { RecordSwipperItem, RecordSwipperUtils } from 'src/app/models/record-swiper';
import { RssItem } from 'src/app/models/rss';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-container-record-items',
  templateUrl: './container-record-items.component.html',
  styleUrls: ['./container-record-items.component.scss'],
})
export class ContainerRecordItemsComponent implements OnInit {
  @Input()
  record: Record;

  @Output()
  selected: EventEmitter<RssItem> = new EventEmitter();

  @Input()
  parentFocused: boolean;

  loadingMore: boolean;
  swiperItems: RecordSwipperItem[];

  constructor(private router: Router) {}

  ngOnInit() {
    this.buildSwiperItems();
  }

  get lastEpisodesTextKey(): string {
    return this.record.icon.icon === IconFormat.FORMAT_VIDEO ? 'rss.latestNews' : 'rss.lastIssues';
  }

  onItemClicked(itemIndex: number) {
    const item = this.record.containerData.lastRssItems[itemIndex];
    this.emitSelectedEvent(item);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  goToViewMore() {
    this.router.navigate(['/rss', Util.slugifyRecord(this.record)]);
  }

  private emitSelectedEvent(item: RssItem) {
    this.selected.emit(item);
  }

  private buildSwiperItems() {
    this.swiperItems = [];
    this.record.containerData.lastRssItems.forEach((rssItem) =>
      this.swiperItems.push(RecordSwipperUtils.fromRssItemToSwiperItem(rssItem))
    );
  }
}
